import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

import { EMPTY } from 'rxjs';
import { catchError, repeatWhen, tap } from 'rxjs/operators';
import { CustomerService } from '@app/customers/_services/customer.service';
import { BaseChildComponent } from '@components/_base/base-child/base-child.component';
import { CustomerSubscription } from '@app/customers/_models/customer-subscription.model';

@Component({
  selector: 'app-client-profile-cards',
  templateUrl: './client-profile-cards.component.html',
  styleUrls: ['./client-profile-cards.component.css']
})
export class ClientProfileCardsComponent extends BaseChildComponent implements OnInit {
  customerSubscriptions: CustomerSubscription[];

  constructor(
    private customerService: CustomerService,
    private translateService: TranslateService
  ) { 
    super();
  }

  ngOnInit(): void { }

  initialize() {
    if (this.isInitialized) return;

    this.customerService.findSubscriptionsByCustomerId(this.parentId).pipe(
      tap(data => this.customerSubscriptions = data),
      catchError(err => {
        console.log(err)
        this.errorMessageSubject.next(this.translateService.instant('messages.errorLoadingData'));
        return EMPTY;
      }),
      repeatWhen(() => this.reload$)
    ).subscribe({
      next: () => this.isInitialized = true
    })
  }
}
